// Rebuy bundle builder: close the filters dropdown on click outside.
// Closes through Rebuy's own close button so its internal state stays in sync.
(function () {
  const SECTION_SEL = '.rebuy-bundle-builder__filter-section';
  const OPEN_PANEL_SEL = '.rebuy-bundle-builder__filter-panel--active';
  const CLOSE_SEL = '.rebuy-bundle-builder__filter-panel-close';

  // Capture phase, so the target is checked before Rebuy re-renders and detaches it
  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;
      if (!(target instanceof Element) || target.closest(SECTION_SEL)) return;

      document.querySelectorAll(OPEN_PANEL_SEL).forEach(function (panel) {
        const close = panel.querySelector(CLOSE_SEL);
        if (close) close.click();
      });
    },
    true
  );
})();
